import axios from "axios";
import { DocumentsHistory } from "./dtos/DocumentsHistory.schema";
import { OperatorDocumentSettings } from "./dtos/Operator.schema";

export const addAdmin = async (email: string): Promise<void> => {
  const res = await axios.put<void>("/admins", {
    email,
  });

  console.log(res.status);
};

export const deleteAdmin = async (userId: string): Promise<void> => {
  const res = await axios.delete<void>(`/admins/${userId}`);
};

export const getPlatformDocumentsHistory = async (): Promise<DocumentsHistory> => {
  const res = await axios.get<DocumentsHistory>(
    `/documents/history`
  );
  return res.data;
};

export const downloadLatestPlatformGdrp = async (): Promise<string> => {
  const res = await axios.get<any>(`/documents/gdpr`);
  return res.data;
};

export const downloadPlatformGdrp = async (
  version: string
): Promise<string> => {
  const res = await axios.get<string>(
    `/documents/gdpr/${version}`
  );
  return res.data;
};

export const uploadPlatformGdrp = async (
  text: string
): Promise<void> => {
  const res = await axios.post<void>(
    `/documents/gdpr`,
    {text: text}
  );
};

export const downloadLatestPlatformGdrpw = async (): Promise<string> => {
  const res = await axios.get<any>(`/documents/gdprw`);
  return res.data;
};

export const downloadPlatformGdprw = async (
  version: string
): Promise<string> => {
  const res = await axios.get<string>(
    `/documents/gdprw/${version}`
  );
  return res.data;
};

export const uploadPlatformGdprw = async (
  text: string
): Promise<void> => {
  const res = await axios.post<void>(
    `/documents/gdprw`,
    {text: text}
  );
};

export const downloadLatestPlatformGtc = async (): Promise<string> => {
  const res = await axios.get<any>(`/documents/gtc`);
  return res.data;
};

export const downloadPlatformGtc = async (
  version: string
): Promise<string> => {
  const res = await axios.get<string>(
    `/documents/gtc/${version}`
  );
  return res.data;
};

export const uploadPlatformGtc = async (
  text: string
): Promise<void> => {
  const res = await axios.post<void>(
    `/documents/gtc`,
    {text: text}
  );
};